'use strict';

angular.module('mobile-apps')
	.directive('variableText',['EntryHighlight', function(EntryHighlight) {
		return {
			restrict: 'E',
			scope:
			{
				text : '@',
				isActive : '='
			},
			link: function (scope, elem, attrs) {

				// Makes sure that white spaces do get displayed
				elem.css({'white-space': 'pre-wrap'});

				function refreshDisplayData() {
					// Escape html to not render the actual html of the input
					var htmlEscapedText = $("<span>").text(scope.text).html();

					// Highlight the variables
					var displayText = EntryHighlight.runHighlightFunctions([EntryHighlight.highlightFunctions.variableHighlightFunction], '', undefined, htmlEscapedText, 'entry', {}, scope.isActive, '-live');

					elem.html(displayText);
				};

				scope.$watch('isActive', function() {
					if (scope.isActive) {
						// When active show all lines
						elem.css({'white-space': 'pre-wrap'});
					} else {
						// When not active show only one line
						elem.css({'white-space': 'nowrap'});
					}
				});

				scope.$watch('text', function() {
					refreshDisplayData();
				});
			}
		};
	}]);


